import config from 'config';
import debug from 'debug';
import { SET_FEATURE_FLAGS } from '~/portals/store/domains/session/actionTypes';
import { ASSET_CARD_ENABLED } from '~/domains/featureFlags/keys';
import * as searchActions from '~/domains/search/actionTypes';
import * as angConstants from '~/utils/ang/constants';
import {
  buildAssetListItem,
  mergeAssetListItems,
  findAssetListItem
} from './utils';
import * as actions from '../actionTypes';

const log = debug('exchange:ang-search:reducer');
const initialState = {
  results: [],
  data: [],
  isLoading: true,
  hasMoreAssets: true
};

const replaceAssetInList = (assetList, newItem) =>
  assetList.map((currentItem) => {
    if (
      currentItem.assetId === newItem.assetId &&
      currentItem.groupId === newItem.groupId
    ) {
      return mergeAssetListItems(newItem, currentItem);
    }

    return currentItem;
  });

const buildNewAssetList = (assetList, { asset, highlight, batchNumber }) => {
  const currentAsset = findAssetListItem(asset, assetList);
  const newItem = buildAssetListItem(asset, highlight, batchNumber);

  log(`new asset received ${asset.groupId}/${asset.assetId}/${asset.version}`);

  if (!currentAsset) {
    log(
      `asset added to list ${asset.groupId}/${asset.assetId}/${asset.version}`
    );

    return assetList.concat(newItem);
  }

  return replaceAssetInList(assetList, newItem);
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_FEATURE_FLAGS: {
      return {
        ...state,
        isAssetCardEnabled: action.featureFlags[ASSET_CARD_ENABLED]
      };
    }

    case searchActions.ADD_LIST_ASSET: {
      const assets = buildNewAssetList(state.data, action);

      return {
        ...state,
        isLoading: false,
        isSearchTriggered: true,
        hasMoreAssets:
          action.isANGPaginationEnabled && state.limit < assets.length,
        data: assets
      };
    }

    case searchActions.TRIGGER_SEARCH: {
      return {
        ...state,
        isLoading: true,
        hasMoreAssets: false,
        isSearchTriggered: true,
        data: [],
        ...(action.limit ? { limit: action.limit } : {})
      };
    }

    case searchActions.FINISH_SEARCH: {
      return {
        ...state,
        isLoading: false
      };
    }

    case actions.SHOW_MORE_ASSETS: {
      const limit = state.limit + angConstants.ANG_PAGINATION_SIZE;

      return {
        ...state,
        limit,
        hasMoreAssets: limit < state.data.length
      };
    }

    case actions.FETCH_ASSETS_SUCCESS: {
      return {
        ...state,
        data: action.result.map((asset) => ({
          groupId: asset.groupId,
          assetId: asset.assetId
        })),
        isLoading: false,
        isSearchTriggered: false,
        hasMoreAssets: action.result.length === config.assetsLimit
      };
    }

    case actions.LOAD_ASSETS_SUCCESS: {
      return {
        ...state,
        data: state.data.concat(
          action.result.map((asset) => ({
            groupId: asset.groupId,
            assetId: asset.assetId
          }))
        ),
        isLoading: false,
        hasMoreAssets: action.result.length === config.assetsLimit
      };
    }

    default:
      return state;
  }
}
